import { combineReducers } from 'redux';

import { reducer as branding } from 'modules/branding';
import { reducer as hellosign } from 'modules/hellosign';

/**
 * Combine all of the redux-reducers into the main `rootReducer`.
 */
export default combineReducers({
    branding,
    hellosign
});
